export default __webpack_public_path__ + "static/astronaut-ac30bd7cfe6201409b07f83894433fd0.png";